export default {"src":"/_next/static/media/ad1_mobile.93a99933.svg","height":745,"width":430,"blurWidth":0,"blurHeight":0};